<template>
  <div
    v-if="pagination"
    class="pagination-container"
    :class="hasPageSize ? '' : 'center'"
  >
    <div
      v-if="hasPageSize"
      class="show-page-size"
      :style="noPadding ? 'width: 150px; padding: 0' : ''"
    >
      <div class="show-page-size-text">顯示數量</div>
      <div>
        <select v-model="pageSize" @change="pageSizeChanged">
          <option v-for="size in pageSizes" :key="size" :value="size">
            {{ size }}
          </option>
        </select>
      </div>
    </div>
    <div class="page-btns-container">
      <div
        class="pagination-direction-btn"
        :class="pagination.HasPrevious ? '' : 'disabled'"
        title="第一頁"
        @click.prevent="pageChanged(1)"
      >
        <img :src="jumpMaxImg" alt="第一頁" />
      </div>
      <div
        class="pagination-direction-btn"
        :class="pagination.HasPrevious ? '' : 'disabled'"
        title="上一頁"
        @click.prevent="pageChanged(pagination.CurrentPage - 1)"
      >
        <img :src="jumpOnceImg" alt="上一頁" />
      </div>
      <div class="page-btns">
        <div
          v-for="page in pages"
          :key="page"
          class="page-btn"
          :class="pagination.CurrentPage == page ? 'active' : ''"
          @click.prevent="pageChanged(page)"
        >
          {{ page }}
        </div>
      </div>
      <div
        class="pagination-direction-btn direction-right"
        :class="pagination.HasNext ? '' : 'disabled'"
        title="下一頁"
        @click.prevent="pageChanged(pagination.CurrentPage + 1)"
      >
        <img :src="jumpOnceImg" alt="下一頁" />
      </div>
      <div
        class="pagination-direction-btn direction-right"
        :class="pagination.HasNext ? '' : 'disabled'"
        title="最後一頁"
        @click.prevent="pageChanged(pagination.PageNumber)"
      >
        <img :src="jumpMaxImg" alt="最後一頁" />
      </div>
    </div>
    <div
      v-if="hasPageSize"
      class="show-page-size total-entries"
      :style="noPadding ? 'width: 150px; padding: 0' : ''"
    >
      <span v-if="hasTotalEntries" class="mr-10px"
        >共 {{ totalEntries }} 筆</span
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1,
      jumpOnceImg: require("@/assets/images/Icon/JumpOnce.svg"),
      jumpMaxImg: require("@/assets/images/Icon/JumpMax.svg"),
      pageSizes: [25, 50, 100, 150, 500],
      pageSize: 25,
    };
  },
  props: ["pagination", "hasPageSize", "noPadding"],
  computed: {
    hasTotalEntries() {
      return Object.prototype.hasOwnProperty.call(
        this.pagination || {},
        "Counts"
      );
    },
    totalEntries() {
      return this.pagination.Counts;
    },
    currentPageSize() {
      return this.pagination.PageSize;
    },
    pages() {
      if (this.pagination.PageNumber == 0) return [];
      else {
        let pages = [];
        let firstPage =
          this.pagination.CurrentPage > 4 ? this.pagination.CurrentPage - 4 : 1;
        let lastPage = firstPage + 8;
        if (lastPage > this.pagination.PageNumber) {
          firstPage -= lastPage - this.pagination.PageNumber;
          if (firstPage < 1) firstPage = 1;
          lastPage = this.pagination.PageNumber;
        }
        for (firstPage; firstPage <= lastPage; firstPage++)
          pages.push(firstPage);
        return pages;
      }
    },
  },
  watch: {
    currentPageSize: {
      handler(value) {
        this.pageSize = value;
      },
      immediate: true,
    },
  },
  methods: {
    pageChanged(page) {
      if (
        page == this.pagination.CurrentPage ||
        page > this.pagination.PageNumber ||
        page < 1
      )
        return;
      this.$emit("pageChanged", page);
    },
    pageSizeChanged() {
      if (this.pageSize == this.pagination.PageSize) return;
      this.$emit("pageSizeChanged", this.pageSize);
    },
  },
};
</script>

<style lang="scss">
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 12px 0;
  &.center {
    justify-content: center !important;
  }
}
.show-page-size {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  padding: 0 10px;
  .show-page-size-text {
    margin-right: 16px;
  }
  select {
    height: 40px;
    padding: 1px 6px 0;
    border: 1px solid #d1d1d1;
    border-radius: 4px;
    font-size: 16px;
  }
  @media screen and (max-width: 767px) {
    width: 80px;
    .show-page-size-text {
      display: none;
    }
  }
}
.total-entries {
  justify-content: flex-end;
  color: #b0b0b0;
}
.page-btns-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagination-direction-btn,
.page-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.pagination-direction-btn {
  &.disabled {
    filter: brightness(3.9);
    cursor: default;
  }
  &.direction-right img {
    transform: rotate(180deg);
  }
}
.page-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  padding-top: 2px;
}
.page-btn {
  margin: 0 3px;
  &.active {
    padding-top: 1px;
    color: white;
    background-color: #82b5d8;
    border-radius: 50%;
  }
}
</style>
